import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import { ManageBannerForm } from '../../../components/SiteAdmin/ManageBanner';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';

function action({ store, intl, params }) {
  const title = intl.formatMessage(messages.editAction);
  const { id } = params;

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;
  let banners = store.getState().adminBanners && store.getState().adminBanners.items;
  let initialValues = null;
  if (banners && Array.isArray(banners)) {
    const banner = banners.find(b => String(b.id) === String(id));
    if (banner) {
      // The API returns translations as a list; the form addresses them as
      // translations.<languageCode>.<field>.
      const translations = (banner.translations || []).reduce((acc, row) => {
        acc[row.language] = {
          tittle: row.tittle || '',
          description: row.description || '',
          imageUrl: row.imageUrl || ''
        };
        return acc;
      }, {});

      initialValues = {
        ...banner,
        isAd: !!banner.isAd,
        shopId: banner.ad ? banner.ad.shopId : '',
        translations
      };
    }
  }

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction
//   if (!restrictUrls('/siteadmin/banner/edit/:id', adminPrivileges, privileges)) {
//     return { redirect: '/siteadmin' };
//   }

  return {
    title,
    component: (
      <AdminLayout>
        <ManageBannerForm mode="edit" initialValues={initialValues} />
      </AdminLayout>
    ),
  };
}

export default action; 